import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../css/blogDetails.css";
import axios from "axios";
import { toast } from "react-toastify";

const BlogDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  const [blog, setBlog] = useState({});
  const url = process.env.REACT_APP_BASE_URL

 
  

  // Fetch all blogs and sort them by the "created" date
  const getAllBlogs = async () => {
    try {
      const response = await axios.get(`${url}/api/blog/list`);
      const sortedBlogs = response.data.data.sort(
        (a, b) => new Date(b.created) - new Date(a.created)
      );
      setBlogs(sortedBlogs.slice(0, 4)); // Limit to 4 most recent blogs
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error fetching data:", error);
      }
    }
  };

  // Fetch a specific blog by its ID
  const getBlogById = async () => {
    try {
      const response = await axios.get(`${url}/api/blog/get/${id}`);
      setBlog(response.data.data);
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error fetching blog:", error);
      }
    }
  };

  useEffect(() => {
    getAllBlogs();
    getBlogById();
  }, [id]);

  if (!blog) {
    return <p>Blog not found!</p>;
  }

  return (
    <>
      <div className="blog-page-container">
        {/* Main Blog Content */}
        <div className="blog-detail-container">
          <h2>
            <span>{blog.title}</span>
          </h2>
          <div className="blog-detail-desc">
            <img src={`${url}/images/${blog.image}`} alt={blog.title} />
            <p dangerouslySetInnerHTML={{ __html: blog.description }}></p>
          </div>
        </div>

        {/* Sticky Aside */}
        <div className="aside">
          <h2>प्रसंग विशेष</h2>
          {blogs.map((relatedBlog) => (
            <div
              className="aside-item"
              key={relatedBlog._id}
              onClick={() => navigate(`/blogs/${relatedBlog._id}`)}
            >
              <div className="aside-item-img-container">
                <img
                  className="aside-item-img"
                  src={`${url}/images/${relatedBlog.image}`}
                  alt={relatedBlog.title}
                />
              </div>
              <div className="aside-info">
                <h4 className="aside-item-title">{relatedBlog.title}</h4>
                <p>{new Date(relatedBlog.created).toLocaleDateString()}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default BlogDetail;
